import { PublicClientApplication } from '@azure/msal-browser';

const msalConfig = {
  auth: {
    clientId: '2ed69bfd-ebaa-4112-afec-5b030dcc5789',
    authority: 'https://login.microsoftonline.com/f87322d2-a04a-4f21-a43c-10e809d318a7',
    redirectUri: window.location.origin + '/login',
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: ['User.Read'],
};

export const msalInstance = new PublicClientApplication(msalConfig);
